/* BIENORA — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  /* Animaciones de entrada al hacer scroll */
  function initReveals() {
    var elementos = document.querySelectorAll('.bn-reveal');
    if (!elementos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elementos.forEach(function (el) { el.classList.add('bn-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bn-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    elementos.forEach(function (el) { observer.observe(el); });
  }

  /* Galería de la página de producto */
  function initGaleria() {
    var galeria = document.querySelector('.bn-galeria');
    if (!galeria) return;
    var principal = galeria.querySelector('.bn-galeria-principal img');
    var minis = galeria.querySelectorAll('.bn-galeria-mini button');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-bn-url');
        if (!url) return;
        principal.src = url;
        principal.removeAttribute('srcset');
        minis.forEach(function (m) { m.classList.remove('bn-mini-activa'); });
        mini.classList.add('bn-mini-activa');
      });
    });
  }

  /* Selector de variantes de la página de producto */
  function initVariantes() {
    var contenedor = document.querySelector('[data-bn-variantes]');
    if (!contenedor) return;
    var datosEl = contenedor.querySelector('[data-bn-datos-variantes]');
    var selects = contenedor.querySelectorAll('select[data-bn-opcion]');
    var inputId = document.querySelector('[data-bn-variante-id]');
    var boton = document.querySelector('[data-bn-boton-compra]');
    var precioWrap = document.querySelector('[data-bn-precio]');
    if (!datosEl || !selects.length || !inputId) return;
    var variantes;
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }
    var textoComprar = boton ? boton.textContent.trim() : '';

    function actualizar() {
      var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.opciones.every(function (op, i) { return op === elegidas[i]; });
      });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioWrap) {
        var html = '<span class="bn-precio-actual">' + variante.precio + '</span>';
        if (variante.precio_antes) {
          html += '<span class="bn-precio-antes">' + variante.precio_antes + '</span>';
        }
        precioWrap.innerHTML = html;
      }
      if (boton) {
        if (variante.disponible) {
          boton.removeAttribute('disabled');
          boton.textContent = textoComprar;
        } else {
          boton.setAttribute('disabled', 'disabled');
          boton.textContent = boton.getAttribute('data-bn-texto-agotado') || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  }

  /* Traduce y viste el botón del formulario de pago contra entrega (Releasit).
     2026-07-20: el usuario bajó manualmente Releasit a la versión anterior (clásica) — cambia toda
     la nomenclatura de clases/ids (prefijo "_rsi-" con guiones, antes era "rsi-" con guion bajo).
     Todo este archivo apunta a la nomenclatura de la versión CLÁSICA. Si Releasit vuelve a cambiar
     de versión, hay que re-mapear (buscar el elemento por su texto visible primero para ubicar la
     clase real, como se hizo esta vez). */
  function initBotonContraentrega() {
    var TEXTO = 'PEDIR CONTRAENTREGA';
    var SUBTEXTO = 'Recibe primero y paga después';

    function vestir(boton) {
      if (boton.getAttribute('data-bn-vestido') === '1') return;
      var span = boton.querySelector('span');
      if (!span) return;
      span.textContent = '';
      span.style.display = 'flex';
      span.style.flexDirection = 'column';
      span.style.alignItems = 'center';
      span.style.lineHeight = '1.3';
      var linea1 = document.createElement('span');
      linea1.textContent = TEXTO;
      linea1.style.display = 'block';
      linea1.style.width = '100%';
      linea1.style.fontWeight = '700';
      linea1.style.letterSpacing = '0.02em';
      linea1.style.whiteSpace = 'nowrap';
      var linea2 = document.createElement('span');
      linea2.textContent = SUBTEXTO;
      linea2.style.display = 'block';
      linea2.style.width = '100%';
      linea2.style.fontWeight = '400';
      linea2.style.fontSize = '0.7em';
      linea2.style.opacity = '0.88';
      linea2.style.whiteSpace = 'nowrap';
      span.appendChild(linea1);
      span.appendChild(linea2);
      boton.style.background = 'linear-gradient(135deg, #6E5FA8, #5A4C92)';
      boton.style.paddingTop = '10px';
      boton.style.paddingBottom = '10px';
      boton.setAttribute('data-bn-vestido', '1');
    }

    function buscarYVestir() {
      document.querySelectorAll('._rsi-buy-now-button').forEach(vestir);
    }

    buscarYVestir();
    var observer = new MutationObserver(buscarYVestir);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Cascada Departamento -> Ciudad en el formulario de pago contra entrega (Releasit) */
  function initDepartamentoCiudad() {
    var CIUDADES = {
      'Bogotá': ['Bogotá'],
      'Amazonas': ['Leticia', 'Puerto Nariño'],
      'Antioquia': ['Medellín', 'Bello', 'Itagüí', 'Envigado', 'Sabaneta', 'Rionegro', 'Apartadó', 'Turbo', 'Caucasia', 'La Ceja', 'El Retiro', 'Copacabana', 'Girardota', 'Caldas', 'La Estrella', 'Marinilla', 'Santa Fe de Antioquia', 'Yarumal', 'Andes', 'Necoclí'],
      'Arauca': ['Arauca', 'Arauquita', 'Saravena', 'Tame', 'Fortul', 'Cravo Norte', 'Puerto Rondón'],
      'Archipiélago de San Andrés Providencia y Santa Catalina': ['San Andrés', 'Providencia'],
      'Atlántico': ['Barranquilla', 'Soledad', 'Malambo', 'Sabanalarga', 'Puerto Colombia', 'Galapa', 'Baranoa', 'Sabanagrande', 'Palmar de Varela', 'Santo Tomás', 'Polonuevo'],
      'Bolívar': ['Cartagena', 'Magangué', 'Turbaco', 'Arjona', 'El Carmen de Bolívar', 'Mompós', 'San Juan Nepomuceno', 'Turbaná', 'María la Baja'],
      'Boyacá': ['Tunja', 'Duitama', 'Sogamoso', 'Chiquinquirá', 'Paipa', 'Villa de Leyva', 'Puerto Boyacá', 'Moniquirá', 'Nobsa', 'Garagoa'],
      'Caldas': ['Manizales', 'La Dorada', 'Chinchiná', 'Villamaría', 'Riosucio', 'Anserma', 'Aguadas', 'Salamina', 'Supía'],
      'Caquetá': ['Florencia', 'San Vicente del Caguán', 'Puerto Rico', 'El Doncello', 'Belén de los Andaquíes', 'Cartagena del Chairá'],
      'Casanare': ['Yopal', 'Aguazul', 'Villanueva', 'Monterrey', 'Tauramena', 'Paz de Ariporo', 'Trinidad'],
      'Cauca': ['Popayán', 'Santander de Quilichao', 'Puerto Tejada', 'Patía', 'Guapi', 'El Bordo', 'Piendamó', 'Silvia'],
      'Cesar': ['Valledupar', 'Aguachica', 'Codazzi', 'Bosconia', 'La Jagua de Ibirico', 'Curumaní', 'San Diego', 'Chiriguaná'],
      'Chocó': ['Quibdó', 'Istmina', 'Condoto', 'Tadó', 'Bahía Solano', 'Nuquí', 'Acandí'],
      'Córdoba': ['Montería', 'Cereté', 'Sahagún', 'Lorica', 'Montelíbano', 'Planeta Rica', 'Tierralta', 'Ciénaga de Oro'],
      'Cundinamarca': ['Soacha', 'Facatativá', 'Zipaquirá', 'Chía', 'Fusagasugá', 'Girardot', 'Mosquera', 'Madrid', 'Funza', 'Cajicá', 'Ubaté', 'La Calera', 'Cota', 'Sibaté'],
      'Guainía': ['Inírida'],
      'Guaviare': ['San José del Guaviare', 'Calamar', 'El Retorno', 'Miraflores'],
      'Huila': ['Neiva', 'Pitalito', 'Garzón', 'La Plata', 'Campoalegre', 'San Agustín', 'Palermo', 'Gigante'],
      'La Guajira': ['Riohacha', 'Maicao', 'Uribia', 'Fonseca', 'Villanueva', 'San Juan del Cesar', 'Barrancas', 'Dibulla'],
      'Magdalena': ['Santa Marta', 'Ciénaga', 'Fundación', 'Aracataca', 'Plato', 'El Banco', 'Zona Bananera'],
      'Meta': ['Villavicencio', 'Acacías', 'Granada', 'San Martín', 'Puerto López', 'Cumaral', 'Restrepo'],
      'Nariño': ['Pasto', 'Tumaco', 'Ipiales', 'Túquerres', 'Samaniego', 'La Unión', 'Sandoná'],
      'Norte de Santander': ['Cúcuta', 'Ocaña', 'Pamplona', 'Villa del Rosario', 'Los Patios', 'Chinácota', 'Tibú'],
      'Putumayo': ['Mocoa', 'Puerto Asís', 'Orito', 'Valle del Guamuez', 'Sibundoy', 'Puerto Guzmán'],
      'Quindío': ['Armenia', 'Calarcá', 'La Tebaida', 'Montenegro', 'Quimbaya', 'Circasia', 'Filandia'],
      'Risaralda': ['Pereira', 'Dosquebradas', 'Santa Rosa de Cabal', 'La Virginia', 'Belén de Umbría', 'Marsella'],
      'Santander': ['Bucaramanga', 'Floridablanca', 'Girón', 'Piedecuesta', 'Barrancabermeja', 'San Gil', 'Barbosa', 'Socorro', 'Málaga'],
      'Sucre': ['Sincelejo', 'Corozal', 'San Marcos', 'Sampués', 'Since', 'Tolú', 'Coveñas'],
      'Tolima': ['Ibagué', 'Espinal', 'Melgar', 'Honda', 'Chaparral', 'Líbano', 'Mariquita', 'Fresno', 'Purificación'],
      'Valle del Cauca': ['Cali', 'Buenaventura', 'Palmira', 'Tuluá', 'Cartago', 'Buga', 'Jamundí', 'Yumbo', 'Candelaria', 'Florida', 'Zarzal'],
      'Vaupés': ['Mitú'],
      'Vichada': ['Puerto Carreño', 'La Primavera', 'Cumaribo']
    };

    function fijarValorInput(input, valor) {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, valor);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('blur', { bubbles: true }));
    }

    function crearSelectCiudad(inputCity) {
      var sel = document.createElement('select');
      sel.setAttribute('data-bn-ciudad-select', '1');
      var cs = getComputedStyle(inputCity);
      sel.style.cssText = 'flex:1;width:100%;box-sizing:border-box;height:' + cs.height + ';padding:' + cs.padding + ';border:0;border-radius:' + cs.borderRadius + ';font-size:' + cs.fontSize + ';font-family:' + cs.fontFamily + ';color:' + cs.color + ';background-color:' + cs.backgroundColor + ';';
      sel.style.setProperty('padding-left', '54px', 'important');
      inputCity.style.display = 'none';
      inputCity.insertAdjacentElement('afterend', sel);

      /* Ícono propio (pin), igual al resto de campos — este select es 100% nuestro, así que se puede
         posicionar una sola vez sin pelear con re-render de React */
      var fila = inputCity.parentElement;
      fila.style.position = 'relative';
      var icono = document.createElement('span');
      icono.setAttribute('data-bn-icono-ciudad', '1');
      icono.style.cssText = 'position:absolute;width:34px;height:34px;border-radius:9px;background:#111111;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:1;';
      icono.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22Z" stroke="#fff" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="9.5" r="2.4" fill="#fff"/></svg>';
      fila.appendChild(icono);

      function posicionarIcono() {
        icono.style.left = (sel.offsetLeft + 8) + 'px';
        icono.style.top = (sel.offsetTop + (sel.offsetHeight - 34) / 2) + 'px';
      }
      posicionarIcono();
      requestAnimationFrame(posicionarIcono);
      setTimeout(posicionarIcono, 300);

      return sel;
    }

    function poblarCiudades(sel, deptTexto, inputCity) {
      sel.innerHTML = '';
      var lista = CIUDADES[deptTexto];
      var vacia = document.createElement('option');
      vacia.value = '';
      vacia.textContent = lista ? 'Ciudad' : 'Selecciona un departamento primero';
      sel.appendChild(vacia);
      if (lista) {
        lista.forEach(function (c) {
          var o = document.createElement('option');
          o.value = c;
          o.textContent = c;
          sel.appendChild(o);
        });
        sel.disabled = false;
      } else {
        sel.disabled = true;
      }
      fijarValorInput(inputCity, '');
    }

    function procesar() {
      var inputCity = document.getElementById('_rsi-field-city');
      var selDept = document.getElementById('_rsi-field-province_country_field');
      if (!inputCity || !selDept) return;
      if (inputCity.getAttribute('data-bn-ciudad-vestido') === '1') return;
      inputCity.setAttribute('data-bn-ciudad-vestido', '1');

      var selCiudad = crearSelectCiudad(inputCity);
      poblarCiudades(selCiudad, selDept.options[selDept.selectedIndex].text, inputCity);

      selDept.addEventListener('change', function () {
        poblarCiudades(selCiudad, selDept.options[selDept.selectedIndex].text, inputCity);
      });

      selCiudad.addEventListener('change', function () {
        fijarValorInput(inputCity, selCiudad.value);
      });
    }

    procesar();
    var observer = new MutationObserver(procesar);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Oculta campos redundantes/no deseados del formulario de pago contra entrega (Releasit, versión clásica) */
  function initLimpiarFormularioReleasit() {
    /* CSS persistente: sobrevive a los re-render del widget */
    if (!document.getElementById('bn-releasit-oculto-css')) {
      var estilo = document.createElement('style');
      estilo.id = 'bn-releasit-oculto-css';
      estilo.textContent =
        '._rsi-modal-fields-item:has(#_rsi-field-zip_code){display:none !important;}' +
        '._rsi-modal-fields-item:has(#_rsi-field-email){display:none !important;}' +
        '._rsi-modal-fields-item:has(#_rsi-field-newsletter_subscribe_checkbox){display:none !important;}';
      document.head.appendChild(estilo);
    }

    /* Ícono cuadrado negro con glifo blanco: en esta versión el ícono original es un background-image
       del propio input (no un div aparte), así que se oculta ese fondo y se agrega un ícono propio
       superpuesto (position:absolute) dentro de la fila, que ya viene con position:relative de fábrica.
       Nunca se toca el input/select de Releasit más allá de su propio style (nada de innerHTML). */
    var GLIFOS = {
      persona: '<svg width="17" height="17" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4Z"/></svg>',
      pin: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22Z" stroke="#fff" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="9.5" r="2.4" fill="#fff"/></svg>',
      lista: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" fill="#fff"/><rect x="7" y="8" width="10" height="1.6" rx="0.8" fill="#111"/><rect x="7" y="11.5" width="10" height="1.6" rx="0.8" fill="#111"/><rect x="7" y="15" width="6" height="1.6" rx="0.8" fill="#111"/></svg>',
      wapp: '<svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884M20.463 3.488A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/></svg>'
    };

    var CAMPOS_ICONO = [
      { id: '_rsi-field-first_name', glifo: 'persona' },
      { id: '_rsi-field-last_name', glifo: 'persona' },
      { id: '_rsi-field-phone', glifo: 'wapp' },
      { id: '_rsi-field-address', glifo: 'pin' },
      { id: '_rsi-field-civic_number', glifo: 'lista' },
      { id: '_rsi-field-province_country_field', glifo: 'pin' }
    ];

    function ponerIcono(campo) {
      var el = document.getElementById(campo.id);
      if (!el) return;
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('padding-left', '54px', 'important');
      var fila = el.parentElement;
      fila.style.position = 'relative';

      var icono = fila.querySelector('[data-bn-icono-campo]');
      if (!icono) {
        icono = document.createElement('span');
        icono.setAttribute('data-bn-icono-campo', '1');
        icono.style.cssText = 'position:absolute;width:34px;height:34px;border-radius:9px;background:#111111;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:1;';
        icono.innerHTML = GLIFOS[campo.glifo];
        fila.appendChild(icono);
      }

      /* La fila es flex-wrap: la etiqueta y el input pueden quedar lado a lado o en líneas separadas
         según el ancho disponible — el ícono se ubica según la posición REAL del input en cada revisión,
         no según la fila completa (que también contiene la etiqueta y cambia de forma según el layout). */
      icono.style.left = (el.offsetLeft + 8) + 'px';
      icono.style.top = (el.offsetTop + (el.offsetHeight - 34) / 2) + 'px';
    }

    /* El campo Teléfono no tenía un placeholder útil en español */
    function traducirPlaceholderTelefono() {
      var telefono = document.getElementById('_rsi-field-phone');
      if (telefono && telefono.placeholder !== 'Teléfono') {
        telefono.placeholder = 'Teléfono';
      }
    }

    function fijarValorInput(input, valor) {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, valor);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function ocultarFilaEnvio() {
      /* El bloque "Shipping method" no siempre se oculta con el CSS de arriba (no tiene :has() aplicable
         por id), así que se ubica por su título de texto y se oculta con !important reforzado cada tick */
      var bloque = document.querySelector('._rsi-build-block-shipping-rates');
      if (bloque) bloque.style.setProperty('display', 'none', 'important');

      /* La línea "Shipping" del resumen de totales también se oculta (siempre es gratis, redundante) */
      document.querySelectorAll('._rsi-modal-checkout-line').forEach(function (fila) {
        var titulo = fila.querySelector('._rsi-modal-checkout-line-title');
        if (titulo && titulo.textContent.trim() === 'Shipping') {
          fila.style.setProperty('display', 'none', 'important');
        }
      });
    }

    function estilizarResumenTotales() {
      var resumen = document.querySelector('._rsi-build-block-totals-summary');
      if (resumen) {
        resumen.style.setProperty('background-color', '#F7F6FB', 'important');
        resumen.style.setProperty('border', '1px solid #E4E1F0', 'important');
        resumen.style.setProperty('border-radius', '12px', 'important');
        resumen.style.setProperty('padding', '16px 18px', 'important');
      }

      document.querySelectorAll('._rsi-modal-checkout-line-title').forEach(function (etq) {
        var esTotal = etq.className.indexOf('bigger') !== -1;
        etq.style.setProperty('font-size', esTotal ? '19px' : '14px', 'important');
        etq.style.setProperty('color', esTotal ? '#17234D' : '#4a4560', 'important');
        etq.style.setProperty('font-weight', esTotal ? '800' : '600', 'important');
      });
      document.querySelectorAll('._rsi-modal-checkout-line-value').forEach(function (val) {
        var esTotal = val.className.indexOf('bigger') !== -1;
        val.style.setProperty('font-size', esTotal ? '22px' : '14px', 'important');
        val.style.setProperty('color', esTotal ? '#17234D' : '#1f1c2e', 'important');
        val.style.setProperty('font-weight', '800', 'important');
      });
    }

    function procesar() {
      /* El campo Zip está oculto por CSS pero Releasit lo exige internamente (plan gratis no permite quitarlo del todo) */
      var zip = document.getElementById('_rsi-field-zip_code');
      if (zip && zip.getAttribute('data-bn-oculto') !== '1' && !zip.value) {
        zip.setAttribute('data-bn-oculto', '1');
        fijarValorInput(zip, '000000');
      }

      ocultarFilaEnvio();
      traducirPlaceholderTelefono();
      CAMPOS_ICONO.forEach(ponerIcono);
      estilizarResumenTotales();
    }

    procesar();
    var observer = new MutationObserver(procesar);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Traduce textos fijos del formulario de pago contra entrega (Releasit) que no tienen opción de idioma en el plan gratis */
  function initTraducirFormularioReleasit() {
    // cache-bust
    var ETIQUETAS = {
      'First name': 'Nombre',
      'Last name': 'Apellido',
      'Phone': 'Teléfono',
      'Address': 'Dirección',
      'Civic number / Address 2': 'Información adicional'
    };

    var PLACEHOLDERS = {
      '_rsi-field-first_name': 'Nombre',
      '_rsi-field-last_name': 'Apellido',
      '_rsi-field-address': 'Dirección',
      '_rsi-field-civic_number': 'Barrio, torre, apto o punto de referencia'
    };

    function procesar() {
      var titulo = document.querySelector('._rsi-modal-header-title');
      if (titulo && titulo.textContent.trim() === 'CASH ON DELIVERY') {
        titulo.textContent = 'PAGO CONTRA ENTREGA';
      }

      Object.keys(PLACEHOLDERS).forEach(function (id) {
        var input = document.getElementById(id);
        if (input && input.placeholder !== PLACEHOLDERS[id]) {
          input.placeholder = PLACEHOLDERS[id];
        }
      });

      document.querySelectorAll('._rsi-modal-fields-item label').forEach(function (etiqueta) {
        var texto = etiqueta.textContent.trim();
        var conAsterisco = texto.slice(-1) === '*';
        var base = conAsterisco ? texto.slice(0, -1).trim() : texto;
        if (ETIQUETAS[base]) etiqueta.textContent = ETIQUETAS[base] + (conAsterisco ? '*' : '');
      });

      document.querySelectorAll('span, div._rsi-custom-text-field').forEach(function (span) {
        if (span.children.length !== 0) return;
        var texto = span.textContent.trim();
        if (texto !== 'Enter your shipping address' && texto !== 'Ingrese su dirección de envío') return;
        if (span.getAttribute('data-bn-titulo-datos') === '1') return;
        span.setAttribute('data-bn-titulo-datos', '1');
        span.textContent = 'Ingresa tus datos aquí';
        span.style.cssText = 'display:inline-flex;align-items:center;background:#EFEBF7;color:#17234D;font-weight:800;font-size:22px;padding:18px 34px;border-radius:999px;height:64px;box-sizing:border-box;flex:1 1 auto;';

        var fila = document.createElement('div');
        fila.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:16px;margin:22px 0 18px;';
        var icono = document.createElement('span');
        icono.style.cssText = 'flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:64px;height:64px;';
        icono.innerHTML = '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="2" width="14" height="20" rx="2" fill="#6E5FA8"/><rect x="6" y="6.5" width="8" height="1.6" rx="0.8" fill="#fff"/><rect x="6" y="10" width="8" height="1.6" rx="0.8" fill="#fff"/><rect x="6" y="13.5" width="5" height="1.6" rx="0.8" fill="#fff"/><circle cx="18" cy="17" r="5" fill="#0E9F6E"/><path d="M15.7 17l1.6 1.6 3-3.2" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

        span.parentElement.insertBefore(fila, span);
        fila.appendChild(icono);
        fila.appendChild(span);
      });

      /* El botón final no se aplica solo: se sincroniza a mano contra el Total real en cada revisión */
      var totalLinea = Array.from(document.querySelectorAll('._rsi-modal-checkout-line')).find(function (l) {
        var t = l.querySelector('._rsi-modal-checkout-line-title');
        return t && t.textContent.trim() === 'Total';
      });
      var totalValor = totalLinea ? totalLinea.querySelector('._rsi-modal-checkout-line-value') : null;
      var botonSpan = document.querySelector('._rsi-modal-submit-button span');
      if (totalValor && botonSpan) {
        var esperado = 'HAZ TU PEDIDO - ' + totalValor.textContent.trim();
        if (botonSpan.textContent.trim() !== esperado) {
          botonSpan.textContent = esperado;
        }
      }
    }

    procesar();
    var observer = new MutationObserver(procesar);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Selector de 1/2/3 unidades con 20% de descuento (versión clásica de Releasit: no trae contador +/-
     dentro del modal, así que la cantidad se fija a mano en el input oculto item_quantity[0] y el
     Subtotal/Descuentos/Total se recalculan aquí mismo — el 20% real vive en Shopify > Descuentos y se
     aplica de verdad al crear el pedido, esto solo refleja en pantalla lo que va a cobrar) */
  function initSelectorCantidad() {
    var PRECIO_UNIDAD = 0;

    function leerPrecioUnidad() {
      var el = document.querySelector('.bn-precio-actual');
      if (!el) return 0;
      var numero = el.textContent.replace(/[^0-9]/g, '');
      return numero ? parseInt(numero, 10) / 100 : 0;
    }

    function formatoCOP(valor) {
      return '$' + valor.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function totalEsperado(cantidad) {
      var bruto = PRECIO_UNIDAD * cantidad;
      return cantidad >= 2 ? Math.round(bruto * 0.8) : bruto;
    }

    function fijarValorInput(input, valor) {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, valor);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function actualizarResumen(cantidad) {
      var subtotal = PRECIO_UNIDAD * cantidad;
      var total = totalEsperado(cantidad);
      var descuento = subtotal - total;

      var lineas = document.querySelectorAll('._rsi-modal-checkout-line');
      var filaSubtotal, filaTotal, filaDescuento;
      lineas.forEach(function (l) {
        var t = l.querySelector('._rsi-modal-checkout-line-title');
        if (!t) return;
        var texto = t.textContent.trim();
        if (texto === 'Subtotal') filaSubtotal = l;
        else if (texto === 'Total') filaTotal = l;
        else if (texto === 'Descuentos') filaDescuento = l;
      });

      if (filaSubtotal) {
        var valorSub = filaSubtotal.querySelector('._rsi-modal-checkout-line-value');
        if (valorSub) valorSub.textContent = formatoCOP(subtotal);
      }
      if (filaTotal) {
        var valorTotal = filaTotal.querySelector('._rsi-modal-checkout-line-value');
        if (valorTotal) valorTotal.textContent = formatoCOP(total);
      }

      if (descuento > 0) {
        if (!filaDescuento && filaSubtotal) {
          filaDescuento = filaSubtotal.cloneNode(true);
          var tituloDesc = filaDescuento.querySelector('._rsi-modal-checkout-line-title');
          tituloDesc.textContent = 'Descuentos';
          filaSubtotal.insertAdjacentElement('afterend', filaDescuento);
        }
        if (filaDescuento) {
          var valorDesc = filaDescuento.querySelector('._rsi-modal-checkout-line-value');
          if (valorDesc) valorDesc.textContent = '-' + formatoCOP(descuento);
          filaDescuento.style.removeProperty('display');
        }
      } else if (filaDescuento) {
        filaDescuento.style.setProperty('display', 'none', 'important');
      }

      var cantidadInput = document.querySelector('._rsi-modal-container input[name="item_quantity[0]"]');
      if (cantidadInput) fijarValorInput(cantidadInput, String(cantidad));
    }

    function crearSelector() {
      PRECIO_UNIDAD = leerPrecioUnidad();
      if (!PRECIO_UNIDAD) return null;

      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-bn-selector-cantidad', '1');
      wrapper.style.cssText = 'display:flex;flex-direction:column;gap:10px;margin:14px 0;';

      var total2 = PRECIO_UNIDAD * 2;
      var total2Desc = Math.round(total2 * 0.8);
      var total3 = PRECIO_UNIDAD * 3;
      var total3Desc = Math.round(total3 * 0.8);

      var modal = document.querySelector('._rsi-modal-container');
      var imgProducto = modal ? modal.querySelector('._rsi-build-block-order-summary img') : null;
      var srcImagen = imgProducto ? imgProducto.src : '';

      var opciones = [
        { cantidad: 1, titulo: 'Compra 1 unidad', precio: formatoCOP(PRECIO_UNIDAD), precioAntes: null, badge: 'Envío gratis', destacado: false },
        { cantidad: 2, titulo: '¡Compra 2 unidades con un 20% de descuento!', precio: formatoCOP(total2Desc), precioAntes: formatoCOP(total2), badge: 'Ahorra 20%', destacado: true },
        { cantidad: 3, titulo: '¡Compra 3 unidades con un 20% de descuento!', precio: formatoCOP(total3Desc), precioAntes: formatoCOP(total3), badge: 'Ahorra 20%', destacado: false }
      ];

      var tarjetas = [];

      opciones.forEach(function (op) {
        var tarjeta = document.createElement('button');
        tarjeta.type = 'button';
        tarjeta.setAttribute('data-bn-cantidad', String(op.cantidad));
        tarjeta.style.cssText = 'position:relative;display:flex;align-items:center;gap:10px;padding:12px 14px;border-radius:12px;border:2px solid ' + (op.destacado ? '#8FD4A6' : '#E4E1F0') + ';background:' + (op.destacado ? '#F0FBF3' : '#fff') + ';cursor:pointer;text-align:left;font-family:inherit;transition:opacity .15s, border-color .15s, background-color .15s, box-shadow .15s;';

        if (op.destacado) {
          var cinta = document.createElement('span');
          cinta.textContent = 'MÁS POPULAR';
          cinta.style.cssText = 'position:absolute;top:-9px;left:14px;background:#2f9e52;color:#fff;font-size:10px;font-weight:800;letter-spacing:.04em;padding:2px 9px;border-radius:999px;box-shadow:0 1px 3px rgba(0,0,0,.15);';
          tarjeta.appendChild(cinta);
        }

        var dot = document.createElement('span');
        dot.setAttribute('data-bn-dot', '1');
        dot.style.cssText = 'flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #C7C2DB;box-sizing:border-box;position:relative;';
        tarjeta.appendChild(dot);

        if (srcImagen) {
          var miniatura = document.createElement('img');
          miniatura.src = srcImagen;
          miniatura.alt = '';
          miniatura.style.cssText = 'flex:0 0 auto;width:42px;height:42px;border-radius:8px;object-fit:cover;border:1px solid #eee;';
          tarjeta.appendChild(miniatura);
        }

        var izq = document.createElement('div');
        izq.style.cssText = 'display:flex;flex-direction:column;gap:4px;min-width:0;flex:1 1 auto;';

        var titulo = document.createElement('span');
        titulo.textContent = op.titulo;
        titulo.style.cssText = 'font-weight:700;font-size:14px;color:#1f1c2e;line-height:1.25;';
        izq.appendChild(titulo);

        var badge = document.createElement('span');
        badge.textContent = op.badge;
        badge.style.cssText = 'display:inline-block;width:fit-content;font-size:11px;font-weight:800;letter-spacing:.02em;padding:2px 9px;border-radius:999px;background:' + (op.destacado ? '#2f9e52' : '#e9f7ef') + ';color:' + (op.destacado ? '#fff' : '#1c7c3f') + ';';
        izq.appendChild(badge);

        var der = document.createElement('div');
        der.style.cssText = 'display:flex;flex-direction:column;align-items:flex-end;gap:2px;flex:0 0 auto;white-space:nowrap;';
        if (op.precioAntes) {
          var antes = document.createElement('span');
          antes.textContent = op.precioAntes;
          antes.style.cssText = 'font-size:12px;color:#9b96ab;text-decoration:line-through;white-space:nowrap;';
          der.appendChild(antes);
        }
        var precio = document.createElement('span');
        precio.textContent = op.precio;
        precio.style.cssText = 'font-size:18px;font-weight:800;color:' + (op.destacado ? '#237a3f' : '#1f1c2e') + ';white-space:nowrap;';
        der.appendChild(precio);

        tarjeta.appendChild(izq);
        tarjeta.appendChild(der);

        tarjeta.addEventListener('click', function () {
          actualizarSeleccion(op.cantidad);
          actualizarResumen(op.cantidad);
        });

        wrapper.appendChild(tarjeta);
        tarjetas.push(tarjeta);
      });

      function actualizarSeleccion(cantidadActiva) {
        tarjetas.forEach(function (t) {
          var activa = t.getAttribute('data-bn-cantidad') === String(cantidadActiva);
          var destacada = opciones[tarjetas.indexOf(t)].destacado;
          var colorBase = destacada ? '#2f9e52' : '#6E5FA8';
          t.style.borderColor = activa ? colorBase : (destacada ? '#8FD4A6' : '#E4E1F0');
          t.style.boxShadow = activa ? '0 0 0 1px ' + colorBase + ', 0 4px 10px rgba(0,0,0,.08)' : 'none';
          if (!destacada) t.style.background = activa ? '#F4F2FA' : '#fff';

          var dot = t.querySelector('[data-bn-dot]');
          if (dot) {
            dot.style.borderColor = activa ? colorBase : '#C7C2DB';
            dot.style.background = activa ? colorBase : 'transparent';
            dot.style.boxShadow = activa ? 'inset 0 0 0 3px #fff' : 'none';
          }
        });
      }

      actualizarSeleccion(1);

      var encabezado = document.createElement('div');
      encabezado.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:14px;margin:18px 0 4px;';

      var textoEncabezado = document.createElement('div');
      textoEncabezado.innerHTML =
        '<span style="display:block;font-style:italic;font-size:16px;color:#17234D;font-weight:500;">Selecciona</span>' +
        '<span style="display:block;font-size:30px;font-weight:800;letter-spacing:-0.02em;color:#17234D;line-height:1.15;">TU OFERTA</span>';
      encabezado.appendChild(textoEncabezado);

      var iconoBolsa = document.createElement('span');
      iconoBolsa.style.cssText = 'flex:0 0 auto;display:inline-flex;';
      iconoBolsa.innerHTML =
        '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M6 8h12l-1 12H7L6 8Z" stroke="#17234D" stroke-width="1.5" stroke-linejoin="round"/>' +
        '<path d="M9 8V6a3 3 0 0 1 6 0v2" stroke="#17234D" stroke-width="1.5" stroke-linecap="round"/>' +
        '<circle cx="18.2" cy="16.8" r="5" fill="#0E9F6E"/>' +
        '<path d="M18.2 14.6v4.4M16 16.8h4.4" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/>' +
        '</svg>';
      encabezado.appendChild(iconoBolsa);

      wrapper.appendChild(encabezado);

      return wrapper;
    }

    function procesar() {
      /* La fila superior con miniatura/nombre/precio del ítem se oculta: solo deben verse las tarjetas de cantidad. Sigue viva en el DOM (Releasit la necesita) */
      var resumenProducto = document.querySelector('._rsi-build-block-order-summary');
      if (resumenProducto) resumenProducto.style.setProperty('display', 'none', 'important');

      var existente = document.querySelector('[data-bn-selector-cantidad]');
      if (existente) return;
      if (!resumenProducto) return;

      var selector = crearSelector();
      if (!selector) return;
      resumenProducto.insertAdjacentElement('afterend', selector);
    }

    procesar();
    var observer = new MutationObserver(procesar);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Oculta el bloque "Contacto" que Shopify agrega solo al final de cada
     política (privacidad, envíos, devoluciones, términos) con el correo y
     dirección reales de la cuenta. No tiene clase propia, así que se ubica
     por el texto del H2 y se oculta ese H2 más todo lo que sigue. */
  function initOcultarContactoPolitica() {
    var contenedor = document.querySelector('.shopify-policy__body');
    if (!contenedor) return;
    var encabezados = contenedor.querySelectorAll('h2');
    encabezados.forEach(function (h2) {
      if (h2.textContent.trim().toLowerCase() !== 'contacto') return;
      h2.style.setProperty('display', 'none', 'important');
      var siguiente = h2.nextElementSibling;
      while (siguiente) {
        siguiente.style.setProperty('display', 'none', 'important');
        siguiente = siguiente.nextElementSibling;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGaleria();
    initVariantes();
    initBotonContraentrega();
    initDepartamentoCiudad();
    initLimpiarFormularioReleasit();
    initTraducirFormularioReleasit();
    initSelectorCantidad();
    initOcultarContactoPolitica();
  });
})();

// cache-bust 1785813569
